module.exports = __webpack_public_path__ + "img/linkedin-brands.98a9acb8.svg";